import { BodyText, H3, PageSection, Subtitle } from 'common/styles/page';
import React from 'react';
import styled from 'styled-components';

// Define the structure for each option
interface Option {
  key: string;
  title: string;
  description: string;
  prompt: string;
}

interface CopilotPromptButtonsProps {
  startConversation: (prompt: string) => void;
}

const CopilotPromptButtons = ({ startConversation }: CopilotPromptButtonsProps) => (
  <PageSection padtop="20px" padleft="15px" padright="15px" style={{ width: '100%' }}>
    <PageSection style={{ width: '100%' }}>
      <Subtitle>What to ask?</Subtitle>
      <BodyText>
        If you aren't sure where to start, here are some easy ice breakers to get you started.
      </BodyText>
    </PageSection>
    <PageSection padtop padbottom style={{ width: '100%' }}>
      <Container>
        {AIPromptButtons.map(option => (
          <Box
            key={option.key}
            onClick={() => {
              startConversation(option.description);
            }}
          >
            <H3>{option.title}</H3>
            <BodyText>{option.description}</BodyText>
          </Box>
        ))}
      </Container>
    </PageSection>
  </PageSection>
);

export default CopilotPromptButtons;

export const AIPromptButtons: Option[] = [
  {
    key: 'generateThemes',
    title: 'Generate Themes',
    description: 'Generate themes for understanding the general trends in your data.',
    prompt: 'Generate themes for understanding the general trends in your data.',
  },
  {
    key: 'pullExamples',
    title: 'Pull Examples',
    description: 'Pull out real examples from your data to help connect certain themes.',
    prompt: 'Pull out real examples from your data to help connect certain themes.',
  },
  {
    key: 'assessRisks',
    title: 'Assess Risks',
    description: 'Assess risks to identify areas of highest risk within your organization.',
    prompt: 'Assess risks to identify areas of highest risk within your organization.',
  },
  {
    key: 'buildSuggestions',
    title: 'Build Suggestions',
    description: 'Build suggestions for you to act on based on the data.',
    prompt: 'Build suggestions for you to act on based on the data.',
  },
];

// Styled components
const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  text-align: center;
`;

const Box = styled.div`
  flex: 1 1 calc(50% - 20px); /* Two boxes per row */
  padding: 20px;
  border: 1px solid #cccccc;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition:
    transform 0.2s,
    background-color 0.2s;

  &:hover {
    background-color: #f0f8ff;
  }
  background-color: 'white';
`;
